module.exports = __webpack_public_path__ + "img/cwy_4_mobile.923bfbc0.jpg";